import { DataBean } from "../DataBean";

export class FixedAssetActiveHistoryByFixed extends DataBean {


    public async getFixedAssetActiveHistoryByFixedAssetItem(idItem:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getFixedAssetActiveHistoryByFixedAssetItem_Number", [idItem]);
    }
    
}